module.exports = __webpack_public_path__ + "static/media/Funnel Konnekt - Google Chrome 11_14_2018 3_41_10 PM.fe204c85.mp4";